import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pick, prop } from 'ramda';

import * as server from 'js/hooks/user/server';
import { userSetUrlTemplatesAction } from 'js/hooks/user/store/buzz/actions';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

const USER_SEGMENTATION = 'user_segmentation';

export const useGetUrlTemplatesForSegmentation = () => {
    const dispatch = useDispatch();
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const {
        casinoName, clientSkin, clientType, userSegmentURLType
    } = useAppSelector(pick(['casinoName', 'clientSkin', 'clientType', 'userSegmentURLType']));

    return useCallback(async () => {
        const response = await server.getURLsRequest({
            urlTypeList: [userSegmentURLType || USER_SEGMENTATION],
            casinoName,
            clientSkin,
            clientType,
            clientPlatform
        });

        dispatch(userSetUrlTemplatesAction((response?.data?.urlList || []).map((el) => el.url)));
    }, [casinoName, clientSkin, clientType, clientPlatform, dispatch, userSegmentURLType]);
};
